import {defineMessages}      from "react-intl";

const COUNTRIES_TRANSLATIONS = defineMessages({
	canada: {id: "DATA.countries.CA", defaultMessage: "Canada"},
	united_states_of_america: {id: "DATA.countries.US", defaultMessage: "États-Unis d'Amérique"}
});

export default COUNTRIES_TRANSLATIONS;
